<template>
  <div class="studycard-record">
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="所属批次">
        <Input
          v-model="searchCondition.name"
          placeholder="请输入所属批次关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        :data-url="dataUrl"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        selectType
        keyField="id"
        method="get"
      ></Grid>
    </div>
  </div>
</template>

<script>
export default {
  name: "studycard-record",
  data() {
    return {
      searchCondition: {
        name: "",
        init: function() {
          this.name = "";
        }
      },
      tableColumns: [
        { title: "卡号", key: "card_number", align: "center", minWidth: 200 },
        { title: "密码", key: "card_pwd", align: "center", minWidth: 200 },
        { title: "所属批次", key: "study_card", align: "center", minWidth: 200 },
        { title: "兑换时间", key: "used_at", align: "center", minWidth: 200 },
        { title: "兑换人", key: "nickname", align: "center", minWidth: 200 },
        { title: "兑换人手机号码", key: "mobile", align: "center", minWidth: 200 }
      ],
      cardID: undefined,
      dataUrl: ""
    };
  },
  created() {
    this.init();
  },
  watch: {
    $route() {
      this.init();
      this.$nextTick(() => {
        this.$refs.grid.searchRefresh();
      });
    }
  },
  methods: {
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.$refs.grid.searchRefresh();
    },
    onrowsFormatter(row) {
      row.forEach(i => {
        i.used_at = this.$pub.timestampToTime(i.used_at);
      });
    },
    init() {
      this.cardID = this.$route.query.id;
      this.dataUrl =
        "/api/studyCard/use/log" + (this.cardID ? "/" + this.cardID : "");
    }
  }
};
</script>